import { PriorityEnumEnumType } from '@mark43/cad-api';
import { AdditionalInfoView, Priority } from '../../types';

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export enum ListDirection {
    HISTORIC = 'HISTORIC',
    CATCHUP = 'CATCHUP',
}

export type UnreadInfos = {
    [Priority.STANDARD]: null | UnreadInfo;
    [Priority.HIGH]: null | UnreadInfo;
};

export type UnreadInfo = { id: number; priority: PriorityEnumEnumType };

export type ActiveRowActionKind = 'edit' | 'delete-confirm';

/**
 * The single row-level action in flight in a narrative panel — an inline edit
 * or an open delete-confirmation. There is at most one at a time.
 *
 * A pinned entry and its chronological twin share the same `info.id`;
 * `isPinnedRow` disambiguates them so only the acting row instance renders the
 * editor / confirmation.
 */
export interface ActiveRowAction {
    id: number;
    kind: ActiveRowActionKind;
    /** true for the pinned-section row, false for the chronological-list row. */
    isPinnedRow: boolean;
}

export type AdditionalInfoNotificationManager = {
    hasUnread: boolean;
    unreadInfos: UnreadInfos;
    markAsRead: (infos: AdditionalInfoView[], immediate?: boolean) => Promise<void>;
    /** Immediately drop notifications for rows that no longer exist (e.g.
     *  deleted via websocket) — such rows can never be scrolled into view, so
     *  their notifications would otherwise be undismissable. */
    discardNotifications?: (ids: number[]) => void;
    earliestUnreadInfo: { id: number } | null;
    syncUnreadPriority: (id: number, priority: UnreadInfo['priority']) => void;
};
